import { tv } from 'tailwind-variants';

const containerStyle = tv({
  base: 'flex gap-x-1 relative w-full',
});

const inputStyle = tv({
  base: 'bg-transparent flex flex-1 h-full min-w-0 w-full max-w-full text-sm text-gray-800 data-[placeholder]:text-sm focus-visible:outline-0',
  variants: {
    startAdornment: {
      true: 'pl-2',
    },
    endAdornment: {
      true: 'pr-2',
    },
    disabled: {
      true: 'disabled:cursor-not-allowed disabled:text-gray-700 read-only:cursor-not-allowed read-only:text-gray-700',
    },
  },
});

const startAdornmentStyle = tv({
  base: 'flex items-center pointer-events-none font-light text-sm',
});

const endAdornmentStyle = tv({
  base: 'flex items-center font-light text-sm z-20',
});

export const textFieldStyles = {
  container: containerStyle,
  input: inputStyle,
  startAdornment: startAdornmentStyle,
  endAdornment: endAdornmentStyle,
};
